import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router } from '@angular/router';
import { PaymentMethodClass } from '@checkout/shared/classes/payment-method.class';
import { LinkBankComponent } from '@core/components/link-bank/link-bank.component';
import { RouterService } from '@core/services/router.service';
import { UtilService } from '@core/services/util.service';
import { LetDirective } from '@ngrx/component';
import { Store } from '@ngrx/store';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PbbNoticeComponent } from '../../../../../core/components/pbb-notice/pbb-notice.component';
import { PaymentMethodListComponent } from '@core/components/payment-method-list/payment-method-list.component';
import { PbbButtonComponent } from '@core/components/pbb-button/pbb-button.component';

@Component({
  selector: 'pbb-payment-method-page',
  templateUrl: './payment-method-page.component.html',
  styleUrls: ['./payment-method-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    LetDirective,
    LinkBankComponent,
    MatButtonModule,
    MatIconModule,
    PbbNoticeComponent,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    PaymentMethodListComponent,
    PbbButtonComponent
  ]
})
export class PaymentMethodPageComponent extends PaymentMethodClass implements OnInit {
  constructor(
    store: Store,
    private readonly route: ActivatedRoute,
    public routerService: RouterService,
    private readonly router: Router,
    translateService: TranslateService,
    _bottomSheet: MatBottomSheet,
    dialog: MatDialog,
    utilService: UtilService
  ) {
    super(store, translateService, _bottomSheet, dialog, utilService);
  }

  ngOnInit(): void {
    const stepData = this.route.snapshot.data['stepData'] || {};
    this.continueToReview = stepData['continueToReview'] || false;
    this.isReturningUser = stepData['isRegistered'] || false;

    if (this.router.url) {
      this.isOrderReview = this.router.url.indexOf('/orderReview') > 0;
    }
    if (stepData['onPopState']) {
      history.pushState(null, 'null', location.href);
      this.routerService.enableBack = !stepData['onPopState'];
    }
  }

  onClickContinue() {
    this.continueToReview
      ? this.router.navigate(['..'], { relativeTo: this.route })
      : this.router.navigate(['../address'], { relativeTo: this.route });
  }
}
